export default __webpack_public_path__ + "static/media/check.77bd108a.svg";